import { useWorkspaceAdmin } from '@/features/workspaces/hooks/useWorkspace';
import { CampaignResponse } from '@/services/endpoints/campaigns/types';
import { format } from 'date-fns';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { CampaignDeleteButton } from './CampaignDeleteButton';
import { CampaignDetailEditableName } from './CampaignDetailEditableName';

type CampaignDetailHeaderProps = {
  campaign: CampaignResponse;
};

export const CampaignDetailHeader: FC<CampaignDetailHeaderProps> = ({ campaign }) => {
  const { t } = useTranslation(['COMMON', 'ALL', 'campaign']);

  const isWorkspaceAdmin = useWorkspaceAdmin();

  return (
    <header className='flex justify-between bg-white-100 px-8 py-4'>
      <div className='flex max-w-[50%] flex-col gap-4'>
        <div>
          <div className='flex items-center gap-4'>
            <CampaignDetailEditableName campaign={campaign} />
          </div>
          <p className='text-sm text-secondary-700'>{campaign.description}</p>
        </div>
        <div className='flex items-end gap-6 text-tertiary-600'>
          <p className='flex gap-1'>
            <span className='font-semibold text-primary-900'>{t('COMMON:id')}:</span> {campaign?.id}
          </p>
          <p className='flex gap-1 text-sm capitalize'>
            {t('campaign:createdAt')}:<span className='font-semibold text-secondary-700'>{format(new Date(campaign.createdOn), 'yyyy-MM-dd HH:mm:ss')}</span>
          </p>
        </div>
      </div>

      <div className='flex items-start gap-6'>{isWorkspaceAdmin && <CampaignDeleteButton buttonText='COMMON:delete' campaign={campaign} />}</div>
    </header>
  );
};
